"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_fees_controller_1 = __importDefault(require("./student-fees.controller"));
var student_fees_html_1 = __importDefault(require("./student-fees.html"));
var student_pay_fee_module_1 = __importDefault(require("./pay/student-pay-fee.module"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.fees", {
        url: "/fees",
        controller: student_fees_controller_1.default,
        controllerAs: "vm",
        template: student_fees_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.fees", [student_pay_fee_module_1.default.name])
    .config(config)
    .controller("StudentFeesController", student_fees_controller_1.default);
